module.exports = "<div class=\"markup\" [id]=\"idData\" semanticDiff [left]=\"leftData\" [right]=\"rightData\"></div>"